import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { transactionPaymentMethod } from '@/optionSets';
import { TransactionPaymentMethod } from '@/database/baseTypes';

interface MethodAutocompleteProps {
  value?: TransactionPaymentMethod;
  error: boolean;
  helperText?: string;
  inputRef?: React.Ref<any>;
  onSelect: (method?: TransactionPaymentMethod) => void;
  sx?: any; // Add sx prop
}

const pinkFocusStyles = {
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#ff00bf',
    },
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: '#ff00bf',
  },
};

const MethodAutocomplete = ({
  value,
  error,
  helperText,
  inputRef,
  onSelect,
  sx,
}: MethodAutocompleteProps) => {
  return (
    <Autocomplete
      options={transactionPaymentMethod}
      noOptionsText='No methods'
      onChange={(_, newValue) => onSelect(newValue?.value ?? undefined)}
      value={
        transactionPaymentMethod.find((option) => option.value === value) ??
        null
      }
      renderInput={(params) => (
        <TextField
          {...params}
          inputRef={inputRef}
          label='Method'
          fullWidth
          error={error}
          helperText={helperText}
          required
          sx={pinkFocusStyles}
        />
      )}
    />
  );
};

export default MethodAutocomplete;
